const PHRASES = [
  "Bakso Urat Jumbo",
  "Tetelan Goreng Renyah",
  "Kuah Kaldu Hangat",
  "Mie Yamin ala Bandung",
  "Dapur Terbuka",
  "Sambal Pedas Mantap",
  "Es Campur Segar",
];

export default function Marquee({ dark = false }) {
  const items = [...PHRASES, ...PHRASES];
  return (
    <div
      className={`overflow-hidden py-5 border-y ${dark ? "bg-terracotta text-cream border-terracotta-dark" : "bg-tint text-terracotta border-line"}`}
      aria-hidden="true"
      data-testid="marquee-strip"
    >
      <div className="flex w-max animate-marquee">
        {items.map((p, i) => (
          <span key={i} className="flex items-center gap-6 px-6 font-display font-black text-xl sm:text-2xl whitespace-nowrap">
            {p}
            <span className={dark ? "text-amberbrand" : "text-amberbrand"}>✳</span>
          </span>
        ))}
      </div>
    </div>
  );
}
